import React from 'react';
import PropTypes from 'prop-types';
import { withFormsy } from 'formsy-react';
import cx from 'classnames';
import Downshift from 'downshift';
import helpers from '../../resources/helpers';

import FormElementWrapper from '../core/FormElementWrapper';

import './TypeAheadInput.scss';

class TypeAheadInput extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			hasFocus: false,
			touched: false,
			hasValue: (props.value || '') !== '',
			value: props.value,
			showOptions: false,
			loading: false,
			options: [],
			items: props.items ? props.items : [],
		};
		this.inputRef = React.createRef();
		this.handleLabelClick = this.handleLabelClick.bind(this);
		this.handleFocus = this.handleFocus.bind(this);
		this.handleBlur = this.handleBlur.bind(this);
		this.handleValueChange = this.handleValueChange.bind(this);
		this.handleKeyUp = this.handleKeyUp.bind(this);
		this.handleOptionClick = this.handleOptionClick.bind(this);
		this.handleInputStateChange = this.handleInputStateChange.bind(this);
	}

	componentWillReceiveProps(props) {
		const value = props.value;
		this.setState({
			hasValue: (value || '') !== '',
			value,
		});
	}

	// Event Handlers
	handleLabelClick() {
		this.inputRef.current.focus();
	}

	handleFocus() {
		if (this.props.onFocus) {
			this.props.onFocus();
		}
		this.setState({
			hasFocus: true,
			touched: true,
		});
	}

	handleBlur() {
		if (this.props.onBlur) {
			this.props.onBlur(this.state.value);
		}
		this.setState({
			hasFocus: false,
		});
	}

	handleValueChange(value) {
		this.props.setValue(value);
		if (this.props.onChange) {
			this.props.onChange(value, this.state.touched);
		}
		this.setState({
			value,
			hasValue: value !== '',
		});
	}

	async handleKeyUp(evt) {
		if (this.props.onKeyPress) {
			const options = await this.props.onKeyPress(evt.target.value);
			const formattedOptions = options.map((option) => {
				if (typeof option === 'string') {
					return {
						display: option,
						value: option,
					};
				} else {
					return option;
				}
			});

			this.setState({
				showOptions: formattedOptions.length > 0,
				options: formattedOptions,
				items: formattedOptions,
			});
		}
	}

	handleOptionClick(option) {
		this.handleValueChange(option.value);
		this.inputRef.current.value = option.value;

		if (this.props.onOptionSelected) {
			this.props.onOptionSelected(option.value, option);
		}
	}
	handleInputStateChange(change, state) {
		switch (change.type) {
			case Downshift.stateChangeTypes.keyDownEnter:
			case Downshift.stateChangeTypes.clickItem:
				this.handleOptionClick(state.selectedItem);
				break;
			case Downshift.stateChangeTypes.changeInput:
				this.handleValueChange(change.inputValue);
				break;
			default:
				break;
		}
	}

	render() {
		const props = this.props;
		const { showError, errorMessage } = helpers.shouldComponentShowError({
			showError: this.props.showError,
			formHasHadAnInValidSubmit: this.props.formHasHadAnInValidSubmit,
			required: this.props.required,
			getErrorMessage: () => props.errorMessage,
			errorMessage: props.errorMessage,
			currentValue: this.state.value,
		});

		return (
			<FormElementWrapper
				label={props.label}
				hideLabel={props.hideLabel}
				tooltip={props.tooltip}
				optionalLabel={props.optionalLabel}
				name={props.name}
				required={props.required}
				hasFocus={this.state.hasFocus}
				hasValue={this.state.hasValue}
				showError={showError}
				errorMessage={errorMessage}
				onLabelClick={this.handleLabelClick}
				handleValueChange={this.handleValueChange}>
				<Downshift itemToString={(item) => (item ? item.value : '')} onStateChange={(change, state) => this.handleInputStateChange(change, state)}>
					{({ getInputProps, getItemProps, getLabelProps, getMenuProps, isOpen, inputValue, highlightedIndex, selectedItem, openMenu }) => (
						<div className={cx('type-ahead-input', { 'type-ahead-input__options-visible': this.state.showOptions && this.state.hasFocus })}>
							<input
								{...getInputProps({
									ref: this.inputRef,
									className: cx('type-ahead-input__input', { 'type-ahead-input__has-error': showError }),
									autoComplete: 'password-new',
									onFocus: (evt) => {
										openMenu();
										this.handleFocus(evt);
									},
									onBlur: this.handleBlur,
									onKeyUp: this.handleKeyUp,
									onChange: (evt) => this.handleValueChange(evt.currentTarget.value),
									name: props.name,
									type: 'text',
									value: this.state.value || '',
									required: props.required,
								})}
							/>
							<ul {...getMenuProps()}>
								{isOpen
									? this.state.items.map((item, index) => (
											<li
												{...getItemProps({
													key: item.value,
													index,
													item,
													className: `${highlightedIndex === index ? 'focus' : ''}`,
												})}>
												{item.value}
											</li>
									  ))
									: null}
							</ul>
						</div>
					)}
				</Downshift>
			</FormElementWrapper>
		);
	}
}

TypeAheadInput.propTypes = {
	required: PropTypes.bool,
	hidden: PropTypes.bool,
	hideLabel: PropTypes.bool,
	lockLabel: PropTypes.bool,
	label: PropTypes.string,
	tooltip: PropTypes.string,
	optionalLabel: PropTypes.string,
	className: PropTypes.string,
	showError: PropTypes.any,
	errorMessage: PropTypes.string,
	getErrorMessage: PropTypes.func,
	name: PropTypes.string.isRequired,
	value: PropTypes.any,
	onChange: PropTypes.func,
	onFocus: PropTypes.func,
	onBlur: PropTypes.func,
	onKeyPress: PropTypes.func,
	onOptionSelected: PropTypes.func,
	formHasHadAnInValidSubmit: PropTypes.bool,
};

export default withFormsy(TypeAheadInput);
